import { render, staticRenderFns } from "./new-progress-info.vue?vue&type=template&id=3031f71b&scoped=true&"
import script from "./new-progress-info.vue?vue&type=script&lang=js&"
export * from "./new-progress-info.vue?vue&type=script&lang=js&"
import style0 from "./new-progress-info.vue?vue&type=style&index=0&id=3031f71b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3031f71b",
  null
  
)

export default component.exports